module.exports = __webpack_public_path__ + "img/GE_2020_Platzhalter_Personal_Management.png";